import React from "react";
interface MetricsData {
  newThisMonth: number;
  totalB2bCustomer: number;
  totalB2cCustomer: number;
  totalCustomer: number;
}

interface MetricsProps {
  metrics: MetricsData;
}
const StatisticsCard: React.FC<MetricsProps> = ({ metrics }) => {
  return (
    <div className="my-7">
      <div className="flex lg:grid lg:grid-cols-4 gap-4 overflow-x-auto scrollbar-hide lg:overflow-visible whitespace-nowrap">
        <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
          <p className="font-bold text-[14px] text-[#475467]">
            Total Customers
            <button type="button"></button>
          </p>
          <h1 className="text-[#2B2B2B] text-[36px] font-extrabold">
            {metrics?.totalCustomer || 0}
          </h1>
        </section>

        {/* Orders Card */}
        <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
          <p className="font-bold text-[14px] text-[#475467]">
            B2B Customers
            <button type="button"></button>
          </p>
          <h1 className="text-[#F59E0B] text-[36px] font-extrabold">
            {metrics?.totalB2bCustomer || 0}
          </h1>
        </section>

        {/* Withdrawals Card */}
        <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
          <p className="font-bold text-[14px] text-[#475467]">
            B2C Customers
            <button type="button"></button>
          </p>
          <h1 className="text-[#F43F5E] text-[36px] font-extrabold">
            {" "}
            {metrics?.totalB2cCustomer || 0}
          </h1>
        </section>
        {/* Out Escrow Card */}

        <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
          <p className="font-bold text-[14px] text-[#475467]">
            New This Month
            <button type="button"></button>
          </p>
          <h1 className="text-[#9AC12A] text-[36px] font-extrabold">
            {metrics?.newThisMonth || 0}
          </h1>
        </section>
      </div>
    </div>
  );
};

export default StatisticsCard;
